import { render, staticRenderFns } from "./EnterTextMsg2.vue?vue&type=template&id=4ebe8122&scoped=true&"
import script from "./EnterTextMsg2.vue?vue&type=script&lang=js&"
export * from "./EnterTextMsg2.vue?vue&type=script&lang=js&"
import style0 from "./EnterTextMsg2.vue?vue&type=style&index=0&id=4ebe8122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe8122",
  null
  
)

export default component.exports